document.addEventListener('DOMContentLoaded', () => {
    class ProductNavigation extends HTMLElement {
        constructor() {
            super();

            this.layout = this.dataset.layout
            this.sectionId = this.dataset.sectionId
            this.sliderElement = this.querySelector(".product-navigation__swiper");
            this.sliderButtonNext = this.querySelector(".product-navigation__button--next");
            this.sliderButtonPrev = this.querySelector(".product-navigation__button--prev");
            this.sliderScrollBar = this.querySelector(".product-navigation__bar");
            this.sectionProduct = this.closest(".shopify-section").querySelector("featured-product")
        }

        connectedCallback() {
            this.initGallery()
        }

        initGallery() {
            if (!this.sliderElement || typeof window.Swiper === 'undefined') return;
            new Swiper(this.sliderElement, this.getSliderConfig());
        }

        getRenderPath(productPath) {
            return `${window.location.origin}${productPath}&section_id=${this.sectionId}`
        }

        getRenderHtml(path) {
            return (
                fetch(path)
                    .then((response) => response.text())
                    .then((response) => {
                        return new DOMParser().parseFromString(response, 'text/html');
                    })
                    .catch((error) => console.error(error))
            )
        }

        updateContent(newHtml) {
            const blockTypes = [
                "media",
                "title",
                "text",
                "quantity_buttons",
                "buy_buttons",
                "accordion",
                "subscription_form",
                "description",
                "review",
                "star_review",
                "extra_description"
            ];

            blockTypes.forEach(blockType => {
                const currentBlocks = this.sectionProduct.querySelectorAll(`[data-id="${blockType}"]`);
                if (currentBlocks.length === 0) return;

                currentBlocks.forEach(currentBlock => {
                    const blockId = currentBlock.getAttribute('data-block-id');
                    const newBlock = newHtml.querySelector(`[data-id="${blockType}"][data-block-id="${blockId}"]`);            
                    if (newBlock) currentBlock.replaceWith(newBlock);
                });
            });

            this.sectionProduct?.reInitFeateredProduct();
        }


        onSubmit(event) {
            event.preventDefault();
            fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                body:  new FormData(event.target)
              })
              .then(response => {
                return response.json();
              })
              .catch((error) => {
                console.error('Error:', error);
            });
        }

        getSliderConfig() {
            const baseConfig = {
                slidesPerView: "auto",
                allowTouchMove: true,
                rewind: this.layout === "desktop" ? true: false,
                focusableElements: 'img',
                touchRatio: 1,
                threshold: 10,
                on: {
                    click: (event) => {
                        const { clickedSlide: currentSlide, clickedIndex, slides } = event;
                        const { dataset: { path } } = currentSlide;
                        const fullPath = this.getRenderPath(path);
                        
                        if (this.layout === "desktop") event.slideTo(clickedIndex);
 
                        this.getRenderHtml(fullPath)
                            .then(response => {                      
                                this.updateContent(response);
                                const form = this.sectionProduct.querySelector("product-form form")
                                form.addEventListener("submit", this.onSubmit.bind(this));
                            }).then(() => {
                                slides.forEach(slide => slide.classList.remove("navigation-slide--active"));
                                slides[clickedIndex].classList.add("navigation-slide--active");
                            })
                    }
                }
            };

            if (this.layout === "desktop") {
                baseConfig.navigation = {
                    nextEl: this.sliderButtonNext,
                    prevEl: this.sliderButtonPrev,
                };
                baseConfig.scrollbar = {
                    el: this.sliderScrollBar,
                    draggable: true,
                    dragSize: 150
                };
            }
            return baseConfig;
        }
    }

    window.customElements.define('product-navigation', ProductNavigation)
})

